import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchCategoryStats } from "actions/category";
import { Loader2, AlignStartVertical, ChevronRight } from "lucide-react";

const CategoryStats = ({ categoryStats, fetchCategoryStats }) => {
    useEffect(() => {
        fetchCategoryStats();
    }, [fetchCategoryStats]);

    if (!categoryStats?.length) {
        return (
            <div className="container py-12 px-4 sm:px-6 lg:px-8">
                <div className="flex justify-center items-center min-h-[200px]">
                    <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
                </div>
            </div>
        );
    }

    // Filter out any categories with zero tools (as a safeguard)
    const categoriesWithTools = categoryStats.filter(({ count }) => count > 0);

    if (!categoriesWithTools.length) {
        return null;
    }

    return (
        <div className="container py-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold tracking-tight mb-8">
                Top Categories
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoriesWithTools.map(({ name, count }) => (
                    <Link
                        key={name}
                        to={`/category/${name}`}
                        className="group block"
                    >
                        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:border-blue-500 hover:shadow-md transition-all duration-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-gray-50 dark:bg-gray-700 rounded-lg group-hover:bg-blue-50 dark:group-hover:bg-blue-900/20 transition-colors">
                                        <AlignStartVertical className="h-4 w-4 text-gray-500 group-hover:text-blue-600 transition-colors" />
                                    </div>
                                    <div>
                                        <h3 className="text-base font-medium text-gray-900 dark:text-gray-100 group-hover:text-blue-600 transition-colors">
                                            {name}
                                        </h3>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            {count}{" "}
                                            {count === 1 ? "tool" : "tools"}
                                        </p>
                                    </div>
                                </div>
                                <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-blue-600 group-hover:translate-x-0.5 transition-all" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    categoryStats: state.category.categoryStats,
});

export default connect(mapStateToProps, { fetchCategoryStats })(CategoryStats);
